import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appPhoneMask]',
})
export class PhoneMaskDirective {
  private previousValue = '';

  constructor(private ngControl: NgControl) {}

  @HostListener('input', ['$event'])
  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/\D/g, ''); // Remove all non-digit characters

    // Check if the user is deleting characters
    if (value.length < this.previousValue.length) {
      this.previousValue = value;
      this.ngControl.control?.setValue(input.value, { emitEvent: false });
      return;
    }

    // Restrict the input to a maximum of 11 digits
    if (value.length > 11) {
      value = value.substring(0, 11);
    }

    // Apply house mask for 10 digits
    if (value.length === 10) {
      input.value = `(${value.substring(0, 2)}) ${value.substring(
        2,
        6
      )}-${value.substring(6)}`;
    }
    // Apply mobile mask for 11 digits
    else if (value.length === 11) {
      input.value = `(${value.substring(0, 2)}) ${value.substring(
        2,
        7
      )}-${value.substring(7)}`;
    }
    // For partial input (less than 10 or 11 digits), apply basic formatting
    else if (value.length > 6) {
      input.value = `(${value.substring(0, 2)}) ${value.substring(
        2,
        7
      )}-${value.substring(7)}`;
    } else if (value.length > 2) {
      input.value = `(${value.substring(0, 2)}) ${value.substring(2)}`;
    } else {
      input.value = value;
    }

    // Set the formatted value back to the form control
    this.ngControl.control?.setValue(input.value, { emitEvent: false });

    // Store the new value to handle future backspace correctly
    this.previousValue = input.value.replace(/\D/g, ''); // Store digits only to allow proper handling of backspace
  }

  // Handle backspace properly
  @HostListener('keydown.backspace', ['$event'])
  onKeydown(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    // Check if backspace is pressed on a mask character ('-', '(', ')', or space)
    if (
      value.endsWith('-') ||
      value.endsWith(') ') ||
      value.endsWith('(') ||
      value.endsWith(' ')
    ) {
      // Remove the last character and prevent the cursor from getting stuck
      input.value = value.slice(0, -1);
      event.preventDefault();
    }
  }
}
